<div style="width: 200px; height: 200px; display: flex; justify-content: center; align-content: center">
  <div class="visual-output">
    <canvas #display height="96px" width="96px"></canvas>
  </div>
</div>
